import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomPercentageInputWrapper, CustomPercentageInputWrapperProps, InputControls } from '..';
import { CustomFormItem } from '../../../custom_shared/components';
import { InputModel } from '../../models';
import { InputWithMeta } from '../../componentTypes';

// Please note that this is a generic component if behavior for your input is different - create a new independent component (like BusinessTypeInput.tsx etc.)

type Props = CustomPercentageInputWrapperProps & {
    message?: string;
};

const GenericPercentageInput: InputWithMeta<Props> = (props: Props) => {
    const { input, label, message, ...rest } = props;

    return (
        <CustomFormItem name={input.guid} message={message} isReadOnly={input.isReadOnly}>
            <CustomPercentageInputWrapper
                input={input}
                label={label + ' %'}
                topRightNode={<InputControls input={input} />}
                {...rest}
            />
        </CustomFormItem>
    );
};

GenericPercentageInput.meta = {
    inputType: InputModel.name
};

export default observer(GenericPercentageInput);
